import { aroundAmount } from "../studio/money";

/**
 * Amount renders a sentence with its dollar figure isolated left to right, so
 * that an amount inside a Persian line reads "$0.01" and not "0.01$>"
 * (05 §Web client; CLAUDE.md §Persian and RTL — a Latin run inside an RTL line
 * needs its own `<bdi>`, or the neutral characters around it swap ends).
 *
 * Give it the message as a function of the amount, so the sentence keeps its
 * own word order in each language:
 *
 *   <Amount sentence={(a) => t.characters.result(n, m, a)} amount={cost} />
 *
 * It lives here rather than beside one screen because every screen that shows
 * a price inside a sentence needs it, and the one that did not had the bug.
 */
export function Amount({
  sentence,
  amount,
}: {
  sentence: (amount: string) => string;
  amount: string;
}) {
  const [before, after] = aroundAmount(sentence);
  return (
    <>
      {before}
      <bdi dir="ltr">{amount}</bdi>
      {after}
    </>
  );
}
